<template>
  <div ref="component" class="slider_and_input cx_style deng" v-if="!isNaN(originSliderValue)">
    <div
      class="flex_box"
      v-if="!extraConfig.styleId || extraConfig.styleId === 1"
      ref="box"
      :style="styleFix"
      :class="inputHeight !== 'large' ? 'el-input-28' : ''"
    >
      <p
        :class="className"
        v-if="title && title.length && titlePosition === 'singleLine' && !extraConfig.hideTitle"
        :style="getTitleStyle"
        class="option_name mr12"
      >
        {{ getTitle }}<span class="layout_info icon-portal-info2" @click="explainDialog = true"></span>
      </p>
      <el-tooltip
        v-if="tips && tips.length"
        :open-delay="delayTime"
        class="item"
        effect="dark"
        :content="tips"
        :placement="tipsPosition"
      >
        <div
          v-show="titlePosition === 'allInOneLine' && (getTitle.length > 0 || className.length)"
          :class="className"
          :style="getTitleStyle"
          class="fs14 mr12"
          ref="titleText"
        >
          {{ getTitle }}
        </div>
      </el-tooltip>
      <div
        v-else
        v-show="titlePosition === 'allInOneLine' && (getTitle.length > 0 || className.length) && !extraConfig.hideTitle"
        :class="className"
        :style="getTitleStyle"
        class="fs14 mr12"
        ref="titleText"
      >
        {{ getTitle }}
      </div>
      <el-slider
        v-show="showSlider && !extraConfig.hideSlider"
        ref="elSlider"
        class="mr12 slider_size"
        :show-tooltip="false"
        v-model="originSliderValue"
        :min="extraConfig.sliderMin"
        :max="extraConfig.sliderMax"
        @input="slideInput"
        @change="slideChange"
      ></el-slider>
      <single-input
        ref="elInput"
        :style="getInputStyle"
        :value.sync="originInputValue"
        :inputSuffixs="inputSuffix"
        :min="extraConfig.sliderMin"
        :max="extraConfig.sliderMax"
      />
    </div>
    <div class="set-item" v-if="extraConfig.styleId === 2">
      <span class="set-title">{{ title }}</span>
      <div class="content font-flex-content">
        <single-input
          style="width: 88px"
          :value.sync="originInputValue"
          :inputSuffixs="inputSuffix"
          placeholder="请输入"
          :min="min"
          :max="max"
        />
        <div class="btn-wrapper">
          <span
            :class="originInputValue === min ? 'disabled num-btn icon-portal-minus' : 'num-btn icon-portal-minus'"
            @click="originInputValue--"
          ></span>
          <span
            :class="originInputValue === max ? 'disabled num-btn icon-portal-plus' : 'num-btn icon-portal-plus'"
            @click="originInputValue++"
          ></span>
        </div>
      </div>
    </div>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        <span>{{ title }}：</span>{{ tips }}
      </p>
      <div class="box">
        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />
        <video :src="explainVideoSrc" controls v-if="explainVideoSrc"></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "@/modules/common.css"
import publicData from "@/modules/mixins/publicData.js"

export default {
  mixins: [publicData],
  name: "sliderAndInput",
  props: {
    defaultValue: undefined,
    config: undefined,
    extraConfig: {
      type: Object,
      default() {
        return {
          hideTitle: false,
          sliderMin: 0,
          sliderMax: 100,
          isDrag: false,
          styleId: 1
        }
      }
    },
    title: {
      type: String
    },
    className: {
      type: String,
      default: ""
    },
    imageTitle: {
      type: Boolean,
      default: false
    },
    titlePosition: {
      type: String,
      default: "allInOneLine"
    },
    suffix: {
      type: String
    },
    value: {
      type: [Number, String, undefined]
    },
    sliderMin: {
      type: Number,
      default: 0
    },
    sliderMax: {
      type: Number,
      default: 100
    },
    inputWidth: {
      type: String,
      default: "large"
    },
    inputHeight: {
      type: String,
      default: "large"
    },
    tips: {
      type: String
    },
    tipsPosition: {
      type: String,
      default: "top"
    },

    showSlider: {
      type: Boolean,
      default: true
    },
    explainImgSrc: {
      type: String
    },
    explainVideoSrc: {
      type: String
    }
  },
  data: function () {
    return {
      delayTime: 1000,
      explainDialog: false
    }
  },
  computed: {
    min() {
      return this.extraConfig.sliderMin || -100
    },
    max() {
      return this.extraConfig.sliderMax || 100
    },
    inputSuffix() {
      return this.extraConfig.suffix || ""
    },
    styleFix() {
      const _style = {
        "--inputHeight": !isNaN(Number(this.inputHeight))
          ? `${this.inputHeight}px`
          : this.inputHeight === "large"
          ? "32px"
          : "28px",
        "--inputWidth": !isNaN(Number(this.extraConfig.inputWidth || this.inputWidth))
          ? `${this.extraConfig.inputWidth || this.inputWidth }px`
          : this.inputWidth === "large"
          ? "96px"
          : "80px"
      }
      if (this.extraConfig?.hideTitle && this.extraConfig?.hideSlider) {
        _style.justifyContent = "flex-end"
      }
      return _style
    },
    getTitle() {
      if (this.imageTitle) {
        return ""
      } else return this.title || ""
    },
    getTitleStyle() {
      if (this.imageTitle) {
        return {
          width: "24px",
          height: "24px",
          backgroundImage: `url(${this.title})`
        }
      } else {
        return { fontSize: "14px" }
      }
    },
    getInputStyle() {
      return { width: this.styleFix["--inputWidth"], height: this.styleFix["--inputHeight"] }
    },
    originSliderValue: {
      get() {
        return this.config === undefined ? this.defaultValue || 0 : parseInt(this.config)
      },
      set(val) {
        if (val.length === 0) return
        if (val == this.originSliderValue || val > this.extraConfig.sliderMax || val < this.extraConfig.sliderMin) return
        this.$emit("update:config", Number(val))
        this.$emit("change", Number(val))
        if (this.isDrag) {
          sessionStorage.setItem("historyValueChangeing", 1)
        }
      }
    },
    originInputValue: {
      get() {
        return this.config === undefined ? this.defaultValue || 0 : parseInt(this.config)
      },
      set(val) {
        if (val.length === 0) return
        if (val == this.originInputValue || val > this.extraConfig.sliderMax || val < this.extraConfig.sliderMin) return
        this.$emit("update:config", Number(val))
        this.$emit("change", Number(val))
      }
    }
  },
  mounted() {
    sessionStorage.removeItem("historyValueChangeing")
  },
  methods: {
    slideInput() {
      this.isDrag = true
    },
    slideChange() {
      this.isDrag = false
      sessionStorage.removeItem("historyValueChangeing")
    }
  }
}
</script>

<style scoped>
.slider_and_input {
  width: 100%;
}
.flex_box {
  width: 100%;
  display: flex;
  align-items: center;
}
.slider_size {
  flex: 1;
  height: 4px;
  background-color: var(--sliderBackGround);
}
.slider_and_input/deep/ .el-input__inner:hover {
  background: var(--inputNuberHoverThemeBgColor) !important;
}
.slider_and_input/deep/ .el-input-28 .el-input__inner {
  height: var(--inputHeight);
  line-height: 22px;
  padding: 4px 0 4px 12px;
  vertical-align: top;
}

.slider_and_input/deep/ .el-input-28 .el-select .el-input__suffix-inner {
  line-height: 28px;
}
.slider_and_input/deep/ .el-input-28 .number-input-box .suffix_text {
  line-height: 28px;
}

.slider_and_input/deep/ .el-input-28 .el-input-group__append .icon-portal-arrows-up {
  margin-bottom: 0;
}
.slider_and_input/deep/ .el-input-28 .suffix_text {
  line-height: 28px;
}
.slider_and_input/deep/ .el-input-28 .el-input-group__append .icon-arrows-bg {
  height: 13px;
}
.text {
  color: var(--text);
}
::v-deep .explainDialog {
  width: 700px;
}
::v-deep .explainDialog .el-dialog__body {
  padding: 16px 24px 24px;
  color: var(--textColor);
}

::v-deep .explainDialog .tips span {
  font-weight: 600;
}

::v-deep .explainDialog .box {
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  height: 366px;
  background: #fafafa;
  margin-top: 16px;
}
.set-item {
  display: flex;
  align-items: flex-start;
  width: 100%;
  .set-title {
    width: 56px;
    margin-right: 12px;
    line-height: 32px;
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    flex-shrink: 0;
  }
  .content {
    flex: 1;
    overflow: hidden;
  }
  &:last-child {
    margin-bottom: 0;
  }
}
.btn-wrapper {
  background-color: var(--inputBg);
  border-radius: 4px;
  padding: 6px 0;
  font-size: 0;
  flex: 1;
  .num-btn {
    display: inline-block;
    width: 50%;
    text-align: center;
    line-height: 20px;
    font-size: 16px;
    cursor: pointer;
    &:not(:last-child) {
      border-right: 1px solid var(--sliderBackGround);
    }
    &:not(.disabled):hover {
      color: var(--themeColor);
    }
    &.disabled {
      color: var(--borderColorSeven);
      cursor: not-allowed;
      pointer-events: none;
    }
  }
}
.font-flex-content {
  display: flex;
  gap: 8px;
  .font-arrangement-btn {
    flex: 1;
    gap: 3px;
    span.divide:not(.select)::after {
      display: block !important;
    }
  }
}
</style>
